import axios from '@/util/request'
const baseURL = process.env.VUE_APP_API_URL

export default {
  getProductBanner: params => axios({ baseURL, url: '/api/product/open/productBanner', method: 'get', params }), // 前台展示banner
  getDiscountList: data => axios({ baseURL, url: '/api/product/open/discount/getDiscountList', method: 'post', data }), // 获取促销活动列表 (促销类型 1-限时促销 2-折扣活动)
  getDiscountProductList: data => axios({ baseURL, url: '/api/product/open/discount/getDiscountProductList', method: 'post', data }), // 获取促销活动详情产品列表
  getDynamicCategroy: data => axios({ baseURL, url: '/api/product/open/dynamicCategroy', method: 'get', data }), // 查询指定品类列表
  getIndexUserRecs: params => axios({ baseURL, url: '/api/product/open/recommend/userRecs', method: 'get', params }), // 首页猜你喜欢
  searchImageList: params => axios({ baseURL, url: '/api/product/open/recommend/searchProductImgList', method: 'get', params }), // 获取商品图片列表（以图搜图）
  indexLookChannel: data => axios({ baseURL, url: '/api/orders/open/lookChannel', method: 'post', data }), // 首页试算运费接口

  getAdvertisingBar: params => axios({ baseURL, url: '/api/product/open/ad/ad', method: 'get', params }), // 获取广告栏

  getProcessingPopup: params => axios({ baseURL, url: '/api/message/open/processingPopup', method: 'get', params }), // 获取进行中的所有页面弹框
  getUserBehaviorConfig: type => axios({ baseURL, url: `/api/store/user/behaviorConfig/${type}`, method: 'get' }), // 获取用户行为信息根据type
  editUserBehaviorConfig: data => axios({ baseURL, url: `/api/store/user/behaviorConfig`, method: 'post', data }), // 新增或编辑用户行为配置信息

  getShopSetInformation: (params) => axios({ baseURL, url: '/api/listings/storeSetting', method: 'GET', params }), // 获取店铺设置信息
  getMenuCustomNav: params => axios({ baseURL, url: `/api/product/open/menu/menus`, method: 'get', params }), // 获取自定义导航菜单

  getOpenProductList: data => axios({ baseURL, url: '/api/product/open/product/list', method: 'post', data }), // 首页猜你喜欢
  getOpenNewInProductList: data => axios({ baseURL, url: '/api/product/open/product/newIn/list', method: 'post', data }) // 首页获取最新商品

}
